import { MarketplaceKey, useAuthStore } from "@/stores/auth";
import { geniFetch } from "./geniBackend";

export const saveMarketplaceToken = async (marketplace: MarketplaceKey, token: string) => {
  // console.log("Connection", marketplace, token);
  const authStore = useAuthStore();

  if (!authStore.cardGeniusAccountProfile?.profileId) throw new Error("CardGenius account profile not found");
  await geniFetch("/account/profile", {
    method: "PATCH",
    body: JSON.stringify({
      marketplaceToken: token,
      metadata: { [marketplace]: token },
    }),
  });
};
